module.exports = __webpack_public_path__ + "static/img/4.530e52f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/eng/4.png
// module id = mcbA
// module chunks = 0